module.exports = "./img/6de9025cdc5d9caa0553bd5dc75b351a.jpg";